import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M16.374 7.083a7.503 7.503 0 1 0-14.012 5.243c.164.41.293.74.293 1.06 0 .896-.864 2.005-.288 2.58s1.684-.287 2.574-.292c.32 0 .655.133 1.065.298q.559.258 1.143.42"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9.115 9.476h.006M6.108 9.476h.006"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "M12.914 14.966a1.5 1.5 0 1 0 0-2.998 1.5 1.5 0 0 0 0 2.998"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "M7.917 13.907v-.88c0-.52.424-.95.95-.95.904 0 1.274-.639.819-1.424a.95.95 0 0 1 .35-1.294l.864-.495a.834.834 0 0 1 1.14.3l.055.095c.45.785 1.189.785 1.644 0l.055-.095a.834.834 0 0 1 1.14-.3l.864.495c.455.26.61.845.35 1.294-.455.785-.085 1.425.82 1.425.519 0 .949.425.949.95v.879c0 .52-.425.95-.95.95-.904 0-1.274.64-.82 1.424a.95.95 0 0 1-.35 1.294l-.864.495a.834.834 0 0 1-1.14-.3l-.054-.095c-.45-.785-1.19-.785-1.644 0l-.055.095a.834.834 0 0 1-1.14.3l-.864-.495a.95.95 0 0 1-.35-1.294c.455-.785.085-1.425-.82-1.425a.95.95 0 0 1-.95-.95"
    }, null, -1)
  ]))]))
}
export default { render: render }